import I18n from 'i18n-js';
import React from 'react';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import ModalButtons from '../ModalButtons/ModalButtons';
import ModalWarning from '../ModalWarning/ModalWarning';
import ChartBuilderNavSteps from './ChartBuilderNavSteps';
import ChartBuilderWorkspace from './ChartBuilderWorkspace';
import ReactPortalsRoot from '../ReactPortalsRoot/ReactPortalsRoot';
import GeneralWarningModal from './GeneralWarningModal';
import DateHelper from '../DateHelper/DateHelper';
const _cloneDeep = require('lodash/cloneDeep');
import { addYears, subYears } from "date-fns";

export default class ChartBuilder extends React.Component{
  constructor(props){
    super(props);
    console.log('constructor props', this.props)
    this.state = {
      step: 'general',
      allowStepNavigation: false,
      loading: false,
      report_details: {},
      errors: [],
      secondaryAxisErrors: {},
      preview_report_details: {},
      activeColorPallet: 'pallette1',
      showConfirmUpdate: false,
      dateRangePickerOpen: false,
    };
    this.onChangeReportDetails = this.onChangeReportDetails.bind(this);
    this.onChangeDataDetailDataSource = this.onChangeDataDetailDataSource.bind(this);
    this.onChangeDataDetailColumn = this.onChangeDataDetailColumn.bind(this);
    this.onChangeColor = this.onChangeColor.bind(this);
    this.onAddSecondaryAxisDetail = this.onAddSecondaryAxisDetail.bind(this);
    this.onRemoveSecondaryAxisDetail = this.onRemoveSecondaryAxisDetail.bind(this);
    this.onAddSegmentOn = this.onAddSegmentOn.bind(this);
    this.removeSegmentOn = this.removeSegmentOn.bind(this);
    this.onDuplicateSecondaryAxisDetail = this.onDuplicateSecondaryAxisDetail.bind(this);
  };

  componentDidMount() {
    var reportDetails = this.props.report_details
    reportDetails.data_details = this.props.report_details.data_details.map((detail) => {
      if (!detail.id) {
        detail.id = this.generateId()
      };
      return detail
    });
    this.setState({ report_details: reportDetails, });
  };

  render(){
    var buttons = this.setButtons();

    if(!this.props.report_details.system_data || this.props.duplicate){
      return(
        <div className="reports-builder">
          <div className="ChartBuilder">
            <div className="panel panel-form">
              <LoadingSpinner show={this.state.loading} />
              <ModalButtons loading={this.state.loading} buttons={buttons} />
              <ChartBuilderNavSteps {...this.state}/>
              <ChartBuilderWorkspace {...this.state}
                date_format={this.props.date_format}
                time_format={this.props.time_format}
                dataSources={this.props.data_sources}
                preview_report_details={this.state.preview_report_details}
                onChangeReportDetails={this.onChangeReportDetails}
                onChangeDataDetailDataSource={this.onChangeDataDetailDataSource}
                onChangeDataDetailColumn={this.onChangeDataDetailColumn}
                onChangeColor={this.onChangeColor}
                onAddSecondaryAxisDetail={this.onAddSecondaryAxisDetail}
                onRemoveSecondaryAxisDetail={this.onRemoveSecondaryAxisDetail}
                onAddSegmentOn={this.onAddSegmentOn}
                onSetSpecificDates={this.onSetSpecificDates}
                removeSegmentOn={this.removeSegmentOn}
                onDuplicateSecondaryAxisDetail={this.onDuplicateSecondaryAxisDetail}
                colorPalettes={this.props.color_palettes}
                toggleDateRangePicker={this.toggleDateRangePicker}
                />
            </div>
          </div>
          {
            this.state.showConfirmUpdate
            ?
            <ReactPortalsRoot
              children={
                [
                  <ModalWarning
                    key="body"
                    title={I18n.t('update') + ` ${this.state.report_details.name} (${this.state.report_details.code})`}
                    body={
                      <GeneralWarningModal
                        translatedString={ I18n.t('update_chart_text') +`: ${this.state.report_details.name}(${this.state.report_details.code})`}
                        />
                      }
                    CancelSubmit
                    onSubmit={this.onSave}
                    onCancel={() => this.setState({ showConfirmUpdate: false })}
                  />
                ]
              }
              wrapperClassNames="ModalWarningWrapper"
            />
            :
            null
          }
        </div>
      );
    } 
  };

  ///////// Change Handlers //////////

  onChangeReportDetails(e){
    var reportDetails = Object.assign({}, this.state.report_details);
    reportDetails[e.target.name] = e.target.value;

    if (e.target.name === 'x_range' && e.target.value != 'specific_dates'){
      reportDetails.start_date = null;
      reportDetails.end_date = null;
    } else if (e.target.name === 'x_range' && e.target.value == 'specific_dates') {
      reportDetails.start_date = new Date();
      reportDetails.end_date = addYears(new Date(), 1);
    }
    
    this.setState({ report_details: reportDetails})
  };

  onChangeDataDetailDataSource(detailId, dataSourceId) {
    var dataDetails = [...this.state.report_details.data_details];
    var dataSource = this.props.data_sources.find(ds => ds.id === dataSourceId)
    var reportDetails = Object.assign({}, this.state.report_details);
    var updateDataDetails = dataDetails.map((detail, idx) => {
      if(detail.id === detailId){
        detail.data_source = dataSource ? dataSource : null;
        detail.data_column_name = null;
        detail.data_type = null;
        detail.segment_ids = null;
        detail.source_detail = null;
        detail.color = null;

        if(detail.chart_element === this.state.report_details.chart_type.primary_chart_element){
          reportDetails.x_label = null;
          reportDetails.y_label = null;
          reportDetails.x_range = null;
          reportDetails.x_grouping = null;
          reportDetails.start_date = null;
          reportDetails.end_date = null;
        };
      };
      return detail;
    });
    
    reportDetails.data_details = updateDataDetails;
    this.setState({ report_details: reportDetails });
  };

  onChangeDataDetailColumn(detailID, dataColumnName, primaryAxisDetail){
    var dataDetails = [...this.state.report_details.data_details];
    var reportDetails = Object.assign({}, this.state.report_details);

    var updateDataDetails = dataDetails.map((detail) => {
      if (detail.id === detailID) {
        if (dataColumnName){
          var sourceDetail = detail.data_source.source_details.find(sd => sd.data_column_name === dataColumnName);
          detail.data_column_name = sourceDetail.data_column_name;
          detail.display_name = detail.data_source.system_data ? I18n.t(sourceDetail.display_name) : sourceDetail.display_name;
          detail.data_type = sourceDetail.data_type;
          detail.source_detail = sourceDetail;
          if (primaryAxisDetail) {
            this.state.report_details.chart_type.primary_chart_element === 'x-axis' ? reportDetails.x_label = this.splitAndCap(sourceDetail.display_name) : reportDetails.y_label = this.splitAndCap(sourceDetail.display_name)
          } else if (!primaryAxisDetail) {
            if (this.state.report_details.chart_type.primary_chart_element === 'x-axis'){
              !this.state.report_details.y_label && detail.chart_element === 'y-axis' ? reportDetails.y_label = this.splitAndCap(sourceDetail.data_type) : null
              !this.state.report_details.second_y_label && detail.chart_element === 'second-y-axis' ? reportDetails.second_y_label = this.splitAndCap(sourceDetail.data_type) : null
            } 
            else {
              !this.state.report_details.x_label ? reportDetails.x_label = this.splitAndCap(sourceDetail.data_type) : null
            };
          };
        } else{
          detail.data_column_name = null;
          detail.display_name = null;
          detail.data_type = null;
          detail.source_detail = null;
          if (primaryAxisDetail){
            reportDetails.x_label = null;
            reportDetails.y_label = null;
            reportDetails.x_range = null;
            reportDetails.x_grouping = null;
            reportDetails.start_date = null;
            reportDetails.end_date = null;
          };
        };
      };
      return detail
    });

    reportDetails.data_details = updateDataDetails;
    this.setState({ report_details: reportDetails });
  }

  onChangeColor(colorObj){
    var dataDetails = [...this.state.report_details.data_details];
    var updateDataDetails = dataDetails.map((dd) =>{
      if(dd.id === colorObj.target.name){
        dd.color = colorObj.target.value;
      };
      return dd;
    });
    var reportDetails = Object.assign({}, this.state.report_details);
    reportDetails.data_details = updateDataDetails;
    this.setState({ report_details: reportDetails });
  };

  onSetSpecificDates = (startDate, endDate) => {
    var reportDetails = _cloneDeep(this.state.report_details)
    reportDetails.start_date = startDate;
    reportDetails.end_date = endDate;
    this.setState({report_details: reportDetails});
  };



  onAddSecondaryAxisDetail(e) {
    var dataDetails = [...this.state.report_details.data_details];
    dataDetails.push({ id: this.generateId(), chart_element: e.target.name, data_column_name: null, color: null, data_type: null, data_source: null });
    var reportDetails = Object.assign({}, this.state.report_details);
    reportDetails.data_details = dataDetails;
    this.setState({ report_details: reportDetails });
  };

  onDuplicateSecondaryAxisDetail(e){
    var dataDetails = [...this.state.report_details.data_details];
    var dupDetail = dataDetails.find(detail => detail.id === e.target.name);
    var newDetail = _cloneDeep(dupDetail);
    newDetail.id = this.generateId();
    newDetail.segment_ids = null;
    newDetail.color = null;
    newDetail.data_column_name = dupDetail.data_column_name ? dupDetail.data_column_name.split('-')[0] : null;
    dataDetails.push(newDetail);
    var reportDetails = _cloneDeep(this.state.report_details);
    reportDetails.data_details = dataDetails;
    this.setState({ report_details: reportDetails });
  };

  onRemoveSecondaryAxisDetail(e){
    var dataDetails = [...this.state.report_details.data_details];
    var updateDataDetails = dataDetails.filter(dd => dd.id !== e.target.name);
    var reportDetails = Object.assign({}, this.state.report_details);
    reportDetails.data_details = updateDataDetails;
    this.setState({ report_details: reportDetails });
  };

  // onSelectSegmentOn=(detailId, segment_id)=>{

  // }

  onAddSegmentOn(detailId, segment_id, multiAllowed, text){

    var dataDetails = [...this.state.report_details.data_details];
    var updateDataDetails = dataDetails.map((dd) => {

      if (dd.id === detailId) {

        if(segment_id){
          multiAllowed && dd.segment_ids && dd.segment_ids.length ? dd.segment_ids.push(segment_id) : dd.segment_ids = [segment_id]; 
          if(!multiAllowed){
            dd.data_column_name = dd.data_column_name += `-${text}`;
            dd.display_name = this.createDisplayName(dd.data_column_name, text);
          }; 
        } else {
          dd.data_column_name = dd.data_column_name.split('-')[0];
          dd.display_name = null;
        };

      };
      return dd;
    });
    var reportDetails = Object.assign({}, this.state.report_details);

    reportDetails.data_details = updateDataDetails;
    this.setState({ report_details: reportDetails });
  };

  removeSegmentOn(detailId, segment_id, multiAllowed){
    var dataDetails = [...this.state.report_details.data_details];
    var updateDataDetails = dataDetails.map((dd) => {
      if (dd.id === detailId) {
        multiAllowed && dd.segment_ids.length ? dd.segment_ids = dd.segment_ids.filter(id => id !== segment_id) : dd.segment_ids = null;
      };
      return dd;
    });
    var reportDetails = Object.assign({}, this.state.report_details);

    reportDetails.data_details = updateDataDetails;
    this.setState({ report_details: reportDetails });
  };

  //////// Helpers /////////

  setButtons(){
    if (this.props.report_details.system_data && !this.props.duplicate){
      return [
        {
          name: I18n.t('ok'),
          html_attributes: [
            'data-dismiss="modal"'
          ]
        },
      ];
    }
    else if (this.state.step === 'preview_chart') {
      return [
        {
          name: I18n.t('prev'),
          html_attributes: this.state.dateRangePickerOpen ? [
            'disabled'
          ] : [],
          onClick: (e) => {
            this.stepBack()
            return false;
          },
        },
        {
          name: I18n.t('submit'),
          button_classes: ['primary'],
          html_attributes: this.state.dateRangePickerOpen ? [
            'disabled'
          ] : [],
          onClick: (e) => {
            this.props.report_details.id ? this.setState({showConfirmUpdate:true}) : this.onSave();
            return false;
          },
        },
      ];
    } else if (this.state.step === 'general'){
      return [
        {
          name: I18n.t('prev'),
          html_attributes: [
            'disabled'
          ],
          onClick: (e) => {
            // this.stepBack()
            return false;
          },
        },
        {
          name: I18n.t('next'),
          button_classes: ['primary'],
          html_attributes: this.state.dateRangePickerOpen ? [
            'disabled'
          ] : [],
          onClick: (e) => {
            this.validateStep()
            return false;
          },
        },
      ];
    } else {
      return [
        {
          name: I18n.t('prev'),
          html_attributes: this.state.dateRangePickerOpen ? [
            'disabled'
          ] : [],
          onClick: (e) => {
            this.stepBack()
            return false;
          },
        },
        {
          name: I18n.t('next'),
          html_attributes: this.state.dateRangePickerOpen ? [
            'disabled'
          ] : [],
          button_classes: ['primary'],
          onClick: (e) => {
            this.validateStep()
            return false;
          },
        },
      ];
    };
  };

  stepBack(){
    if (this.state.step === 'preview_chart'){
      this.state.report_details.chart_type.name === 'dual_axis_line_chart' ? this.setState({ step: 'second_y_axis' }) : this.setState({ step: 'secondary_axis_details' })
    } else if (this.state.step === 'primary_axis_details'){
      this.setState({ step: 'general' })
    } else if (this.state.step === 'secondary_axis_details'){
      this.setState({ step: 'primary_axis_details' })
    } else if (this.state.step === 'second_y_axis'){
      this.setState({ step: 'secondary_axis_details'})
    };
  };

  ////// Helper Functions /////
  generateId() {
    var text = "";
    var possible = "0123456789";

    for (var i = 0; i < 9; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    };
    return '-' + text;
  };

  splitAndCap(string) {
    return string.toLowerCase().replace(/_/g, " ").split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ');
  };

  toggleDateRangePicker = (isVisable) => {
    if (isVisable != this.state.dateRangePickerOpen){
      this.setState({ dateRangePickerOpen: isVisable })
    };
  };

  createDisplayName(dataColumnName, text){

    if (dataColumnName.includes('charges')){
      return `${text}(${I18n.t('charges')})`
    } else if (dataColumnName.includes('adjustments')){
      return `${text}(${I18n.t('reversals')})`
    } else if (dataColumnName.includes('total')){
      return `${text}(${I18n.t('total')})`
    } else if (dataColumnName.includes('occupancy')) {
      return `${text}(${I18n.t('occupancy')})`
    } else if (dataColumnName.includes('revpar')) {
      return `${text}(RevPar)`
    } else if (dataColumnName.includes('adr')) {
      return `${text}(ADR)`
    } else if (dataColumnName.includes('alos')) {
      return `${text}(ALOS)`
    } else if (dataColumnName.includes('lead_time')) {
      return `${text}(${I18n.t('lead_time')})`
    }
    
  };


  /// Network Requests /////
  setParams(){
    var reportDetailParams = JSON.parse(JSON.stringify(this.state.report_details));
    if (reportDetailParams.data_details && reportDetailParams.data_details.length) {
      reportDetailParams.data_details = reportDetailParams.data_details.map((data) => {
        var detail = {
          temp_id: data.id,
          chart_element: data.chart_element,
          color: data.color,
          data_column_name: data.data_column_name,
          display_name: data.display_name,
          reports_data_source_id: data.data_source ? data.data_source.id : null,
          data_type: data.data_type,
          segment_ids: data.segment_ids
        }
        return detail
      });
      reportDetailParams.data_details = reportDetailParams.data_details.map(data => JSON.stringify(data))
    };
    return reportDetailParams
  };

  ////// Ajax /////

  validateStep() {
    // this.setState({loading: true});
    var reportDetailParams = this.setParams();
    $.ajax({
      type: 'POST',
      url: `/admin/reports/report-details/validate_step`,
      data: {
        report_detail: reportDetailParams,
        step: this.state.step,
      }
    }).done((data) => {
      if(data.errors && data.errors.length) {
        this.setState({ errors: data.errors, loading: false, secondaryAxisErrors: data.data_details_errors ? data.data_details_errors : null });
      } else {
        // if (this.state.report_details.chart_type && this.state.report_details.chart_type.name && (this.state.report_details.chart_type.name === 'line_chart' || 'area_chart' ||)){
          if(this.state.step === 'general'){
              this.setState({ step: 'primary_axis_details', loading: false, errors: [] });
          } else if (this.state.step === 'primary_axis_details'){
            this.setState({ step: 'secondary_axis_details', loading: false, errors: [] });
          } else if (this.state.step === 'secondary_axis_details'){
            let report_details = _cloneDeep(data.report_details)
              // report_details.start_date = DateHelper.parseDateFromBackend(report_details.start_date)
              // report_details.end_date = DateHelper.parseDateFromBackend(report_details.end_date)
            this.setState({ step: this.state.report_details.chart_type.name === 'dual_axis_line_chart' ? 'second_y_axis' : 'preview_chart', loading: false, errors: [], secondaryAxisErrors: null, preview_report_details: report_details});
          } else if (this.state.step === 'second_y_axis'){
            let report_details = _cloneDeep(data.report_details)
            report_details.start_date = DateHelper.parseDateFromBackend(report_details.start_date)
            report_details.end_date = DateHelper.parseDateFromBackend(report_details.end_date)
            this.setState({ step: 'preview_chart', loading: false, errors: [], secondaryAxisErrors: null, preview_report_details: report_details });
          };
        };
      // };
    });
  };

  onSave= ()=>{
    // this.setState({loading: true});
    var reportDetailParams = this.setParams();
    
    $.ajax({
      type: this.props.new_record ? 'POST' : 'PATCH',
      url: this.props.form_action,
      data: {
        report_detail: reportDetailParams,
      }
    }).done((data) => {
      if (data.success) {
        window.parent.$(window.parent).trigger('report_saved_successfully', data);
        window.parent.$(window.parent).trigger('updateChart');
        this.setState({ loading: false });
        if (parent && parent.refresh_data) {
          parent.refresh_data(I18n.t('report_saved_successfully'));
        }

        if (parent && parent.hide_modal) {
          parent.hide_modal();
        }
      }
      if (data.errors) {
        this.setState({
          errors: data.errors
        });
      };
    });
  };

};